// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_pj-0";